import Marquee from "react-fast-marquee";
import { TID } from "@/lib/testIds";

const ITEMS = [
  "Eastern Suburbs",
  "Elite Youth Development",
  "Ages up to 18",
  "1-on-1 & Small Group",
  "Court IQ",
  "Confidence · Craft · Character",
];

export const EditorialMarquee = () => (
  <section
    data-testid={TID.marquee}
    className="relative py-10 md:py-14 border-y border-white/10 bg-[#060b14]"
  >
    <Marquee gradient={false} speed={40} pauseOnHover>
      {ITEMS.concat(ITEMS).map((item, i) => (
        <span
          key={i}
          className="font-display uppercase text-6xl md:text-8xl leading-none px-8 md:px-14 tracking-tight flex items-center"
        >
          {item}
          <span className="text-[#2a5fdb] mx-8 md:mx-14 text-4xl md:text-6xl leading-none">
            ◆
          </span>
        </span>
      ))}
    </Marquee>
  </section>
);
